export var CenterCityEnum;
(function (CenterCityEnum) {
    CenterCityEnum[CenterCityEnum["DEFAULT"] = 1] = "DEFAULT";
    // 兜底城市
    CenterCityEnum[CenterCityEnum["LOCATE"] = 2] = "LOCATE";
    // 定位城市
    CenterCityEnum[CenterCityEnum["SELECT"] = 3] = "SELECT";
    // 选择城市
    CenterCityEnum[CenterCityEnum["CONSTANT"] = 4] = "CONSTANT"; // 常驻地
})(CenterCityEnum || (CenterCityEnum = {}));
export var SurroundingType;
(function (SurroundingType) {
    /** 长三角 */
    SurroundingType[SurroundingType["YANGTZE_RIVER_DELTA"] = 1] = "YANGTZE_RIVER_DELTA";
    /** 珠三角 */
    SurroundingType[SurroundingType["PEARL_RIVER_DELTA"] = 2] = "PEARL_RIVER_DELTA";
    /** 京津冀 */
    SurroundingType[SurroundingType["JING_JIN_JI"] = 3] = "JING_JIN_JI";
    /** 川渝 */
    SurroundingType[SurroundingType["SICHUAN_CHONGQING"] = 4] = "SICHUAN_CHONGQING";
    /** 周边城市 */
    SurroundingType[SurroundingType["SURROUNDING_CITIES"] = 5] = "SURROUNDING_CITIES";
})(SurroundingType || (SurroundingType = {}));
export const SurroundingTypeDesc = {
    [SurroundingType.YANGTZE_RIVER_DELTA]: '长三角',
    [SurroundingType.PEARL_RIVER_DELTA]: '珠三角',
    [SurroundingType.JING_JIN_JI]: '京津冀',
    [SurroundingType.SICHUAN_CHONGQING]: '川渝',
    [SurroundingType.SURROUNDING_CITIES]: '周边城市'
};
/**
 * ========== 3.10 城市体验信息查询 ==========
 */
/**
 * 玩法属性类型枚举
 */
export var PlayAttributeType;
(function (PlayAttributeType) {
    /** 体验亮点 */
    PlayAttributeType[PlayAttributeType["EXPERIENCE_HIGHLIGHT"] = 101] = "EXPERIENCE_HIGHLIGHT";
    /** 实用Tips */
    PlayAttributeType[PlayAttributeType["USEFUL_TIPS"] = 102] = "USEFUL_TIPS";
    /** 驾车时间 */
    PlayAttributeType[PlayAttributeType["TRAFFIC_DISTANCE_DESC"] = 103] = "TRAFFIC_DISTANCE_DESC";
    // 暂不使用
    PlayAttributeType[PlayAttributeType["ACTIVITY_TIME"] = 1] = "ACTIVITY_TIME";
    // 活动时间
    PlayAttributeType[PlayAttributeType["CHARGE_STANDARD"] = 2] = "CHARGE_STANDARD";
    // 收费标准
    PlayAttributeType[PlayAttributeType["PLAY_TIME"] = 3] = "PLAY_TIME";
    // 游玩时长
    PlayAttributeType[PlayAttributeType["DISTANCE"] = 4] = "DISTANCE";
    // 距离
    PlayAttributeType[PlayAttributeType["PARK_TRANSPORTATION"] = 5] = "PARK_TRANSPORTATION";
    // 园内交通
    PlayAttributeType[PlayAttributeType["BROWSE_ROUTE"] = 6] = "BROWSE_ROUTE";
    // 浏览路线
    PlayAttributeType[PlayAttributeType["PLAY_LIMIT"] = 7] = "PLAY_LIMIT";
    // 游玩限制
    PlayAttributeType[PlayAttributeType["FOOD_LOCATION"] = 8] = "FOOD_LOCATION"; // 餐酒地址
})(PlayAttributeType || (PlayAttributeType = {}));
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["VACATION"] = 2] = "VACATION";
    /** 门票 */
    ProductType[ProductType["TICKET"] = 3] = "TICKET";
})(ProductType || (ProductType = {}));
/** 数据类型，2-目的地体验，3-运营兜底离线给的目的地攻略数据 */
export var ContentType;
(function (ContentType) {
    ContentType[ContentType["EXPERIENCE"] = 2] = "EXPERIENCE";
    ContentType[ContentType["OPERATION"] = 3] = "OPERATION";
})(ContentType || (ContentType = {}));
